import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Dialog, Snackbar } from "@core/material";
import { Select, Store } from "@ngxs/store";
import { Observable, ReplaySubject, Subject } from "rxjs";
import { InitReportSampleLinkForm, QueryReports, ReportSampleLinkFormState, ReportSampleLinkFormStateModel, ReportSampleLinkQuery } from "./report-sample-link-form.dialog.state";
import { Report } from "@core/data";
import { debounceTime, takeUntil } from "rxjs/operators";
import { InitReportBuilder, RemoteAddMultipleSamplesToReport } from "../report-builder/report-builder.state";

export interface ReportSampleLinkFormDialogData {
    orgKey: string;
    sampleKeys: string[];
}
@Component({
    selector: 'pv-report-sample-link-form-dialog',
    templateUrl: './report-sample-link-form.dialog.html',
    styleUrls: ['./report-sample-link-form.dialog.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
})
export class ReportSampleLinkFormDialog implements OnInit, OnDestroy {

    @Select(ReportSampleLinkFormState)
    state$: Observable<ReportSampleLinkFormStateModel>;

    @Select(ReportSampleLinkFormState.query)
    query$: Observable<ReportSampleLinkQuery>;

    reportFilterControl: FormControl = new FormControl('');
    filteredReports: ReplaySubject<Report[]> = new ReplaySubject<Report[]>(1);

    reportControl: FormControl = new FormControl([], [Validators.required]);
    searchControl = new FormControl();
    scionCultivarsControl = new FormControl([]);

    selectedReport: Report;

    formGroup: FormGroup = new FormGroup({
        report: this.reportControl,
        samples: new FormControl(this.data.sampleKeys),
    })

    queryFormGroup = new FormGroup({
        search: this.searchControl,
        scionCultivars: this.scionCultivarsControl,
    });

    private _destroy$ = new Subject();

    constructor(
        private _store: Store,
        private _dialogRef: MatDialogRef<ReportSampleLinkFormDialog>,
        private _snackbar: Snackbar,
        private _dialog: Dialog,
        @Inject(MAT_DIALOG_DATA) public data: ReportSampleLinkFormDialogData,
    ) {}

    ngOnInit() {
        this._store.dispatch(new InitReportSampleLinkForm(this.data.orgKey, this.data.sampleKeys));

        // apply state changes to query form
        this.query$.pipe(takeUntil(this._destroy$))
            .subscribe(query => this.queryFormGroup.patchValue(query, { emitEvent: false }));

        // handle query changes
        this.queryFormGroup.valueChanges
            .pipe(debounceTime(300), takeUntil(this._destroy$))
            .subscribe(val => {

                let data: ReportSampleLinkQuery = {
                    ...val,
                }

                this._store.dispatch(new QueryReports(data));
            });

        this.reportControl.valueChanges
            .pipe(takeUntil(this._destroy$))
            .subscribe(key => {
                if (!key) return;

                this._store.dispatch(new InitReportBuilder(key));
            })
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    attempt() {
        if (!this.formGroup.valid) return this._snackbar.error('Invalid Input. Check your input and try again.');

        const form = this.formGroup.value;

        this._store.dispatch(new RemoteAddMultipleSamplesToReport(form.report, form.samples, true));

        this._dialogRef.close();
    }

    cancel() {
        this._dialogRef.close(false);
    }
}